<template>
  <div>
    <lock-icon fillColor="#b32a2a" :size="50" />
    <span class="unauthorized-text">Não autorizado!</span>
  </div>
</template>

<script>
import LockIcon from "vue-material-design-icons/Lock.vue";

export default {
  name: "Login",
  components: {
    LockIcon
  }
};
</script>

<style lang="scss" scoped>
div {
  text-align: center;
  margin: 20% auto 0;

  .unauthorized-text {
    display: block;
  }
}
</style>
